<template>
    <div class="composition">
        <b-row>
            <b-col class="pt-2 pt-md-0 pt-lg-1 mb-1"
            >
                <b-alert variant="warning"
                         class="mb-0 mt-0"
                         show
                >
                    <i class="fa fa-info"></i>
                    Clasifique sustancias, soluciones diluidas y mezclas, no reacciones.
                    <b-btn variant="warning"
                           size="sm"
                           class="float-right"
                           style="padding: 1px 5px 2px 6px"
                           @click="openModal"
                    >
                        Ver más
                    </b-btn>
                </b-alert>
            </b-col>
        </b-row>

        <!-- Filtros -->
        <b-row>
            <!-- Nombre -->
            <b-col md="6">
                <el-input id="name"
                          name="name"
                          ref="name"
                          v-model="name"
                          size="small"
                          type="text"
                          placeholder="Filtrar por componentes"
                />
                <i v-if="!!name.length"
                   @click="name = ''"
                   title="Cancelar, y restablecer datos."
                   class="fa fa-close filter-search-form-calc-icon-cancel cursor-pointer"
                />
            </b-col>

            <!-- Botones -->
            <b-col md="6"
                   class="mt-1"
            >
                <b-button v-if="!only_view"
                          @click="openModalForCreation()"
                          variant="primary"
                          size="sm"
                          class="mx-1"
                >
                    <i class="fa fa-plus mr-1"></i>
                    <span class="d-none d-md-inline-block"> Agregar</span>
                </b-button>

                <b-button @click="downloadComposition"
                          variant="info"
                          class="mx-1"
                          size="sm"
                          v-if="product.raw_materials.length && mode === 1"
                >
                    <i class="fa fa-file-pdf-o mr-1"></i>
                    <span class="d-none d-md-inline-block"> Descargar</span>
                </b-button>

                <b-button-group class="float-right mr-1"
                                size="sm"
                >
                    <b-button @click="setMode(2)"
                              :variant="mode === 2 ? 'secondary' : 'light'"
                    >
                        <i class="fa fa-list"/>
                    </b-button>
                    <b-button @click="setMode(1)"
                              :variant="mode === 1 ? 'secondary' : 'light'"
                    >
                        <i class="fa fa-table"/>
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>

        <template v-if="mode === 1">
            <grid :name="name"
                  key="grid-mode"
                  @create="openModalForCreation"
            />
        </template>
        <template v-else>
            <form_mode :name="name"
                       key="form-mode"
                       @create="openModalForCreation"
            />
        </template>

        <raw_material_new/>

        <component_form/>
        <new_component/>
        <wizard/>

        <raw_materials_list/>

        <modal ref="modal"/>
<!--                <RawMaterialCard ></RawMaterialCard>-->
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import component_form from './component';
import new_component from './new_component';
import wizard from './wizard.vue';
import input_formatter from '../../components/input_formatter';
import grid from './grid.vue';
import form_mode from './form_mode.vue';
import raw_materials_list from './raw_materials_list.vue';
import raw_material_new from './raw_material_form.vue';
import modal from './modal.vue';
import RawMaterialCard from './RawMaterialCard.vue';

export default {
    name: 'index',
    components: {
        grid,
        modal,
        form_mode,
        wizard,
        component_form,
        new_component,
        input_formatter,
        raw_material_new,
        raw_materials_list,
        RawMaterialCard
    },
    data() {
        return {
            name: '',
            info_modal: true,
            columns: [
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'percentage',
                    label: 'Porcentaje usado'
                },
                {
                    key: 'components',
                    label: 'Componentes'
                },
                {
                    key: 'actions',
                    label: ''
                }
            ]
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'modal_components',
            'modal_wizard',
            'only_view',
            'mode'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'deleteRawMaterial',
            'updateRawMaterial',
            'getProduct',
            'updateComponents',
            'downloadComposition',
            'updateComponentProduct',
            'getRawMaterials',
            'getRawMaterialCompany'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setActionRawMaterialShow',
            'setRawMaterial',
            'setModalComponentsShow',
            'setShowToModalWizard',
            'setStepToModalWizard',
            'resetRawMaterial',
            'setMode',
            'setShowToModalRawMaterials',
            'resetParamsInModalRawMaterials',
            'setRawMaterials',
            'setActionToModalRawMaterial'
        ]),
        openModal() {
            this.$refs.modal.openModal();
        },
        async openModalForCreation() {
            this.resetParamsInModalRawMaterials();
            await this.getRawMaterials();
            this.setShowToModalRawMaterials(true);
        },
        async _deleteRawMaterial(rm) {
            await this.deleteRawMaterial(rm);

            await this.getProduct({
                product_id: this.product.id,
                company_id: this.product.slq_company_id
            });
        },
        async changePercentage(rm) {
            this.$refs.name.focus();

            let reg = new RegExp('^(\\d{0,2}(\\.\\d{1,2})?|100(\\.00?)?)$');

            if (reg.test(rm.percentage.toString())) {
                await this.updateRawMaterial(rm);

                await this.getProduct({
                    product_id: this.product.id,
                    company_id: this.product.slq_company_id
                });
            }
        },
        async changeReportedPercentage(c) {
            await this.updateComponentProduct(c);

            await this.getProduct({
                product_id: this.product.id,
                company_id: this.product.slq_company_id
            });
        }
    }
};
</script>

<style>
.composition {
    .filter-search-form-calc-icon-cancel {
        position: absolute;
        right: 1.4rem;
        top: .45rem;
        color: #9c9c9c;
        font-size: 1.1rem;
    }
}
</style>
